import { PeakSignalType } from "../../../../data/entities";

export const SIGNAL_LABELS: Record<PeakSignalType, string> = {
  LF: "Flaw Signal",
  LMA: "Rolling Avg Deviation",
};

export const formatTime = (isoString: string) =>
  new Date(isoString).toLocaleString("en-US", {
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit",
    second: "2-digit",
    hour12: true,
  });

export const formatNumber = (value: number) =>
  value.toLocaleString(undefined, {
    maximumFractionDigits: Math.abs(value) >= 100 ? 0 : Math.abs(value) >= 1 ? 2 : 4,
  });
